import CartIconLoader from './Loader';

export default CartIconLoader;
